import React, { lazy } from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="pt-6 pb-6 sm:pt-10 sm:pb-12 px-4 overflow-hidden flex flex-col justify-center bg-brand-cream" data-id="element-96">
      <div className="max-w-2xl mx-auto text-center" data-id="element-97">
        <div className="inline-block bg-brand-sage-light text-brand-olive font-bold px-3 py-1 rounded-full text-[10px] sm:text-xs uppercase tracking-wide mb-4" data-id="element-98">
          ✨ WISSENSCHAFTLICH VALIDIERTE ERNÄHRUNGSMETHODE
        </div>

        <h1 className="text-3xl sm:text-5xl md:text-6xl font-serif font-bold text-brand-text-main leading-[1.1] mb-4 sm:mb-6" data-id="element-99">
          METABOLIK PRO
        </h1>

        <p className="text-sm sm:text-lg text-brand-text-muted leading-relaxed mb-4 sm:mb-6 max-w-xl mx-auto font-medium" data-id="element-100">
          Kennen Sie diese Symptome — Blutzuckerschwankungen, Erschöpfung nach
          dem Essen, Schlafprobleme? <br className="hidden sm:block" data-id="element-101" />
          <span className="font-bold text-brand-text-main" data-id="element-102">
            500 getestete Rezepte ohne Zucker und ohne Gluten
          </span>{' '}
          — für jede Mahlzeit Ihres Tages. Mit echtem Genuss.
        </p>

        <div className="mb-6 sm:mb-8" data-id="element-103">
          <a href="#pricing" className="block cursor-pointer" data-id="element-104">
            <img src="https://cdn.magicpatterns.com/uploads/1T9hQF7qcyLX9WVP3qmGdh/metabolik-alemania-.webp" alt="Metabolik Pro - 6 Bücher" loading="lazy" className="w-full h-auto object-contain drop-shadow-xl max-w-lg mx-auto" data-id="element-105" />
          </a>
        </div>

        <div data-id="element-106">
          <CTAButton href="#pricing" className="w-full sm:w-auto sm:min-w-[300px]" variant="premium" data-id="element-107">
            🌿 Ich will mein System jetzt
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-2 mt-4 sm:mt-6 text-xs sm:text-sm text-brand-text-muted font-medium" data-id="element-108">
          <span className="flex items-center gap-1" data-id="element-109">
            <span className="text-brand-gold" data-id="element-110">⭐⭐⭐⭐⭐</span> 4.9/5 —
            Verifizierte Bewertungen
          </span>
          <span className="hidden sm:inline text-brand-text-muted/50" data-id="element-111">•</span>
          <span className="flex items-center gap-1" data-id="element-112">
            🛡️ 30-Tage-Garantie — Null Risiko
          </span>
        </div>
      </div>
    </section>;
}